module.exports = __webpack_public_path__ + "img/result.bd7ac465.png";